import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
/** @class CardHeaderMixin */

/** @method */

export var CardHeaderMixin = function CardHeaderMixin(props) {
  return token({
    fontType: "CardHeader.fontType",
    borderColor: "Card.separatorColor"
  }, function (_ref) {
    var fontType = _ref.fontType,
        borderColor = _ref.borderColor;
    return css(["", " padding-bottom:", ";border-bottom:1px solid ", ";margin-top:0;margin-bottom:", ";", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), spaceMixin("sm")(props), borderColor, spaceMixin("md")(props), spacingMixin(props));
  })(props);
};